<template>

<div  >
<div class="modal fade bd-example-modal-lg fondo-modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">  
      <!-- <object  data="https://themisfsweb.poderjudicialags.gob.mx/Constancia.pdf" type="application/pdf"></object> -->
    <PDFV2     :porPaginas="true"  :conImprimir="true" :conDescarga="true" ref="pdf" v-if="rutaDelDocumento != null" :url="rutaDelDocumento" :key="rutaDelDocumento"></PDFV2>
   <button class="btn btn-danger cerrarElVisor"   @click="CierraElVisor()"><i class="fas fa-times" ></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar el documento</button>
    </div>
  </div>
</div>
</div>

</template>
<script>
import PDFDocument from '@/components/Comunes/PDFDocument.vue';
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import PDFV2 from '@/components/Comunes/VisorPDFV2.vue';
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    data() {
        return {
            RUTA_SERVER_LOCAL:'\\\\themisfstest' ,
            RutaDelArchivo:null    
        }
    },
     components: {
    PDFDocument,
    PDFV2
  }, 
  computed: {
    rutaDelDocumento() {
        $('.bd-example-modal-lg').modal('show')
      //  console.log("rutaaaaaaaaaaaaaaaaaaa;;;; ",this.RutaDelArchivo)
       // this.rutaDelDocumento = "https://themisfsweb.poderjudicialags.gob.mx/Constancia.pdf";
      return this.RutaDelArchivo;
    }
  }, 
  methods: {
  
     DescargarArchivo: function(rutaArchivo) {
          let target =false;
          let href = false;
          var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (target) ? "_blank" : '';
            a.href = (href) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
  
 },
      CierraElVisor: function() {
      $('.bd-example-modal-lg').modal('hide')
      this.RutaDelArchivo=null;
      this.$router.push('/');

      },
      AbrirVisor:function(){
           let vinculo =this.$route.query.file
           this.RutaDelArchivo= vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,this.RUTA_SERVER_LOCAL);
      }
  },
  
    mounted() {
   
        this.AbrirVisor();
        
    },
}
</script>

<style scoped>
.contenedor-descarga{
  background-color: forestgreen;

}

.btn-flotante {
position: relative;
height: 4em !important;
}
.fondo-modal{
  width: "100%" !important;
  background-color:  dimgrey;
}
.caja-pdf{
 width:100% !important;
 position: relative;
 background-color: firebrick;
}

.contenedor-opciones{
  background-color: rgb(209, 208, 208);
  bottom: 0;
    position: sticky !important;
     position: -webkit-sticky !important;
    align-items: center;
    top: 0px;
    width: 100%;
    height: 4em;
    z-index: 1;
    margin-left: 10px;
    text-align: center;
}
header{
  height:170px;
  color:#FFF;
  font-size:20px;
  font-family:Sans-serif;
  background:#009688;
  padding-top:30px;
  padding-left:50px;
}
.contenedor{
  width:90px;
  height:240px;
  position:absolute;
  right:10%;
  z-index: 1;
  top:3%;
}

  #visorDeDocumento_div {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 100 !important;
  }

  #cargandoVisorDocumento_div {
    background: rgba(34,34,34,.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100 !important
  }

    #cargandoVisorDocumento_div > #secciongeneral > div {
      width: 100vw;
      height: 100vh;
      align-content: center;
    }

    #cargandoVisorDocumento_div > #secciongeneral {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,.5);
    }

  .cerrarElVisor {
    bottom: 0;
    position: sticky;
    font-size:2.5vh;
    width: 100%;
    height: 2.5em;
  }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-top: 3vh;
  }

  h4 {
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 2vh;
  }

  i {
    color: #FFFFFF;
    position: absolute;
    top: 10px;
    left: 10px;
  }

  .PDFDocument {
    width: 100vw;
    height: 100vh;
  }

  @media screen and (min-width: 992px){
.modal-lg {
    max-width: 1200px;
}
}

@media screen and (min-width: 576px){
.modal-dialog {
    max-width: 1300px;
    margin: 1.75rem auto;
}
}
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaPrincipal/VisualizarPdfDesdeDireccion.vue